export default "__VITE_PUBLIC_ASSET__0e09b51e__"